
if( document.querySelector('.wp-block-gallery, .attachment-gallery') ) {
	
	const [
		lightGallery,
		nogonadExif,
		lgVideo,
		lgFullScreen,
		lgZoom,
		lgThumbnail,
	] = await Promise.all([
		import('./lightgallery.js'),
		import('./lg-nogonad-exif.js'),
		import('./lg-video.js'),
		import('./lg-fullscreen.js'),
		import('./lg-zoom.js'),
		import('./lg-thumbnail.js'),
	]);
	
	['lightgallery.css', 'lg-fullscreen.css', 'lg-video.css', 'lg-thumbnail.css', 'lg-zoom.css', 'lg-nogonad-exif.css'].forEach( cssFile =>
		addLightGalleryCSS(cssFile)
	);
	
	addLightGalleryCSS('https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200', false);
	
	document.querySelectorAll('.wp-block-gallery, .attachment-gallery').forEach(el => {
		lightGallery.default(el, {
			plugins: [lgVideo.default, lgFullScreen.default, lgZoom.default, lgThumbnail.default, nogonadExif.default],
			speed: 500,
			licenseKey: 'YOUR_LICENSE_KEY',
			selector: 'a',
			thumbnail: true,
			closable: true,
			swipeToClose: false,
			mobileSettings: {
				showCloseIcon: true,
				controls: false,
				download: false,
			}
		});
	});
	
}

function addLightGalleryCSS(css, relative = true) {
	const link = document.createElement('link');
	link.rel = 'stylesheet';
	link.href = relative ? `${nogonadLightGalleryURL}/css/${css}` : css;
	document.head.appendChild(link);
}